import { UniqueIdentifier, useDndContext } from "@dnd-kit/core";
import { CSSProperties } from "react";
import { RowData } from "../../components/Table";
import { StyledTrProps } from "../../components/Table/styles";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";

const BORDER = `2px solid ${defaultTheme.COLORS.ACTION_BLUE}`;

export const withDraggableProps = <D extends RowData, P extends StyledTrProps>(
  WrappedComponent: React.ComponentType<P>,
  { items, activeId }: { items: D[]; activeId: UniqueIdentifier | null },
) => {
  return (props: P) => {
    const { over } = useDndContext();

    const activeIndex = items.findIndex((item) => item.id === activeId);

    const overIndex = over?.id
      ? items.findIndex((item) => item.id === over?.id)
      : -1;

    const isActiveRow = over?.id === props.$rowId;

    const style: CSSProperties = {
      borderBottom: isActiveRow && overIndex > activeIndex ? BORDER : undefined,
      borderTop: isActiveRow && overIndex < activeIndex ? BORDER : undefined,
    };

    return <WrappedComponent style={style} key={props.$rowId} {...props} />;
  };
};
